export default __webpack_public_path__ + "ce8387b69990b7af49b040ac9fdc1e16.png";